import React from 'react';
import styled from 'styled-components';

import Descriptions from 'antd/es/descriptions';

import { Row, Col } from 'components/layout';
import { Title } from 'components/Text';

const IndividualReport = React.forwardRef((props, ref) => {
  const { individual, dateRange, children, ...rest } = props;

  return (
    <IndividualReportWrapper ref={ref} {...rest}>
      <Row className="print-only" style={{ padding: '0 24px' }}>
        <Col span={24}>
          <Title level={2}>
          Firestone Individual Performance Report
          </Title>
          <Descriptions>
            <Descriptions.Item label="Individual">
              {individual.full_name}
            </Descriptions.Item>
            <Descriptions.Item label="Agency">
              {individual.agency}
            </Descriptions.Item>
            <Descriptions.Item label="Stats">
              {dateRange.start && dateRange.start.format('DD/MM/YYYY')}
              {' - '}
              {dateRange.end && dateRange.end.format('DD/MM/YYYY')}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {children}
        </Col>
      </Row>
    </IndividualReportWrapper>
  );
});

const IndividualReportWrapper = styled.div`
  .print-only {
    display: none;
  }
  
  @media print {
    display: block;
    
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }

    .print-only {
      display: inherit;
    }

    .no-print {
      display: none;
    }

    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }

  @page {
    size: auto;
    margin: 15mm;
  }
`;

export default IndividualReport;
